import { WeaveBillPayPortal } from '@frontend/weave-pay-portal';

export const WeaveBillPayApp = () => {
  return <WeaveBillPayPortal />;
};

export default WeaveBillPayApp;
